import { DropdownItem } from '@shared/abstraction';
import { SecurityStatus } from '@shared/enums/security-status';

export const taxResultStatusItems: DropdownItem[] = [
  {
    value: SecurityStatus.All,
    label: 'All',
  },
  {
    value: SecurityStatus.Approved,
    label: 'Approved',
  },
  {
    value: SecurityStatus.PendingApproval,
    label: 'Pending approval',
  },
];
